export * from './UIGamePlayerCardInventory.tsx';
